<template>
    <div class="third_step-container">
        <h1>{{translate("select_material_sort")}}</h1>
        <div class="elements-container">
            <third-step-element v-for="element in getThirdStepElements"
                                :id="element.id"
                                :key="element.id"
                                :name="element.title_translation_code"
                                :img-src="element.imgSrc">
            </third-step-element>
            <div class="element question-link" @click="showModal">
                <span class="name">{{translate("other_materials")}}</span>
                <span class="text">{{translate("send_request")}}</span>
            </div>
            <third-step-modal-mail v-if="isModalVisible"
                                   @close="closeModal"
                                   :target="'material'">
            </third-step-modal-mail>

        </div>
    </div>
</template>

<script>
    import ThirdStepElement from '@/components/configuration_steps/thirdStep/ThirdStepElement.vue'
    import ThirdStepModalMail from '@/components/configuration_steps/thirdStep/ThirdStepModalMail.vue'

    export default {
        name: "ThirdStep",
        components: {ThirdStepElement, ThirdStepModalMail},
        data() {
            return {
                isModalVisible: false
            }
        },
        computed: {
            getThirdStepElements() {
                return this.$store.state.thirdStepElements;
            }
        },
        methods: {
            showModal() {
                this.isModalVisible = true;
            },

            closeModal() {
                this.isModalVisible = false;
            },

            changeStep(step) {
                this.$store.commit({
                    type: 'changeActiveConfigurationStep',
                    step: step
                })
            },

            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);
                return arg.out;
            },

            compare(a, b) {
                const bandA = this.translate(a.title_translation_code).toUpperCase();
                const bandB = this.translate(b.title_translation_code).toUpperCase();

                return bandA.localeCompare(bandB);
            },

            loadElements() {
                this.$store.commit('loadThirdStepData');

                if (this.$store.state.thirdStepElements.length < 2) {
                    let defaultId = -1;

                    if (this.$store.state.thirdStepElements.length == 1 && this.$store.state.thirdStepElements[0].id)
                        defaultId = this.$store.state.thirdStepElements[0].id;

                    this.selectDefaultElement(defaultId);
                }

                this.$store.state.thirdStepElements.sort(this.compare);
            },
            selectDefaultElement(id, name, imgSrc) {

                this.$store.commit({
                    type: 'selectThirdStepElement',
                    id: id,
                    name: name,
                    imgSrc: imgSrc,
                });
                this.changeStep(4);
            },
        },
        beforeMount() {
            this.$store.state.thirdStepElements = [];
            this.loadElements();
        }
    }
</script>

<style scoped>

</style>
